import type { Operator } from '@/features/location/types/location-info.types';

/**
 * Monta is the platform's master operator (operator id 1). Selecting the
 * synthetic "Monta" entry in the operator filter sends `operator_ids=1`, which
 * the API resolves to Monta-operated charge points.
 *
 * NOTE: this was previously `0`, but operator id 0 does not exist — so the old
 * value matched nothing. Keep this at 1. See the `monta-operator` memory / the
 * country map-suggestion `operator_ids:[0]` placeholder, which is an own-brand
 * marker, NOT a usable charge-point filter value.
 */
export const MONTA_OPERATOR_ID = 1;

/** The synthetic "Monta" entry shown first in the operator filter. */
export const montaOperator: Operator = {
  id: MONTA_OPERATOR_ID,
  name: 'Monta',
  teamIds: [],
  operatorIds: [MONTA_OPERATOR_ID],
};

/**
 * Build the operator-filter list: Monta always first, followed by the
 * location-based operators with any API-provided Monta entry removed (matched
 * by name or by operator id) so Monta is never listed twice.
 *
 * @param locationOperators operators returned for the current location (may be
 *   undefined while loading)
 */
export function buildOperatorList(
  locationOperators: Operator[] | undefined
): Operator[] {
  const deduped = locationOperators?.filter(
    (op) =>
      op.name?.toLowerCase() !== 'monta' &&
      !op.operatorIds?.includes(MONTA_OPERATOR_ID)
  );
  return deduped ? [montaOperator, ...deduped] : [montaOperator];
}
